import apiSlice from './ApiSlice';

export const CampaignGroupApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // GET ALL
        getAllCampaignGroup: builder.query({
            providesTags: ["campaign-group"],
            query: () => {
                return {
                    url: '/campaign-group',
                    method: 'GET',
                };
            },
        }),
         // GET ALL WITH PAGINATION
         getAllCampaignGroupWithPagination: builder.query({
            providesTags: ["campaign-group"],
            query: () => {
                return {
                    url: '/campaign-group',
                    method: 'POST',
                };
            },
        }),

        // Add 
        addCampaignGroup: builder.mutation({
            invalidatesTags: ["campaign-group"],
            query: (body) => {
                return {
                    url: '/campaign-group/add',
                    method: 'POST',
                    body
                };
            },
        }),

        // EDIT
        editCampaignGroup: builder.mutation({
            invalidatesTags: ["campaign-group"],
            query: ({ body, id }: any) => {
                return {
                    url: `/campaign-group/${id}`,
                    method: 'PUT',
                    body
                };
            },
        }),

        //Single View
        viewCampaignGroupById: builder.query({
            providesTags: ["campaign-group"],
            query: (id: any) => {
                return {
                    url: `/campaign-group/${id}`,
                    method: "GET",
                };
            },
        }),

        // Delete
        deleteCampaignGroup: builder.mutation({
            invalidatesTags: ["campaign-group"],
            query: (id: string) => {
                return {
                    url: `/campaign-group/${id}`,
                    method: 'DELETE',
                };
            },
        }),

    }),
});

export const { useGetAllCampaignGroupQuery, useDeleteCampaignGroupMutation, useAddCampaignGroupMutation, useEditCampaignGroupMutation , useViewCampaignGroupByIdQuery , useGetAllCampaignGroupWithPaginationQuery} = CampaignGroupApi;